__turbopack_context__.v({
  "root": "g052na_root",
  "toolbar": "g052na_toolbar",
});
